import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PriceDifferenceComponent } from './price-difference.component';
import { DatePipeModule } from '../date/date.module';
import { PipesModule } from '../pipes/pipes.module';
import { PriceDifferenceService } from './price-difference.service';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';

@NgModule({
    imports: [
        CommonModule,
        PipesModule,
        PricePipesModule,
        PricePipeModule,
        DatePipeModule
    ],
    declarations: [
        PriceDifferenceComponent,
    ],
    exports: [
        PriceDifferenceComponent,
    ],
    providers: [
        PriceDifferenceService
    ]
})
export class PriceDifferenceModule {}